<script setup lang="ts">
import { BillingInfo } from '@/@types'
import { Accordion, AccordionContent, AccordionTrigger } from '@/components/ui/accordion'
import AccordionItem from '@/components/ui/accordion/AccordionItem.vue'
import { Card } from '@/components/ui/card'
import { Title } from '@/components/ui/title'
import DisabledField from '../../DisabledField.vue'

defineProps<{ billing_info: BillingInfo }>()
</script>

<template>
    <Accordion :as="Card" collapsible class="border-transparent">
        <AccordionItem value="additional">
            <AccordionTrigger class="font-sans text-2xl font-semibold text-gray-800">{{ $t('Additional information') }}</AccordionTrigger>
            <AccordionContent class="p-4">
                <section class="space-y-8">
                    <fieldset>
                        <Title as="legend" class="mb-4 !text-xl">{{ $t('Personal data') }}</Title>

                        <div class="grid gap-x-2 gap-y-6 rounded-lg bg-gray-50 px-6 py-4 md:grid-cols-2 lg:grid-cols-3 lg:gap-x-8">
                            <div class="flex flex-col gap-1" v-if="billing_info?.full_name">
                                <div>{{ $t('Name') }}</div>

                                <DisabledField>
                                    {{ billing_info?.full_name }}
                                </DisabledField>
                            </div>
                            <div class="flex flex-col gap-1" v-if="billing_info?.legal_name">
                                <div>{{ $t('Corporate reason') }}</div>

                                <DisabledField>
                                    {{ billing_info?.legal_name }}
                                </DisabledField>
                            </div>
                            <div class="flex flex-col gap-1" v-if="billing_info?.ssn">
                                <div v-if="billing_info?.has_foreign_doc">{{ $t('Foreign document') }}</div>
                                <div v-else>{{ $t('CPF') }}</div>

                                <DisabledField>
                                    {{ billing_info?.ssn }}
                                </DisabledField>
                            </div>

                            <div class="flex flex-col gap-1" v-if="billing_info?.ein">
                                <div>{{ $t('CNPJ') }}</div>

                                <DisabledField>
                                    {{ billing_info?.ein }}
                                </DisabledField>
                            </div>

                            <div class="flex flex-col gap-1">
                                <div>{{ $t('Email to send the invoice') }}</div>

                                <DisabledField>
                                    {{ billing_info?.email }}
                                </DisabledField>
                            </div>

                            <div class="flex flex-col gap-1">
                                <div>{{ $t('Cellphone') }}</div>

                                <DisabledField>
                                    {{ billing_info?.phone_number }}
                                </DisabledField>
                            </div>

                            <div class="flex flex-col gap-1">
                                <div>{{ $t('Phone') }}</div>

                                <DisabledField>
                                    {{ billing_info?.another_phone_number }}
                                </DisabledField>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset>
                        <Title as="legend" class="mb-4 !text-xl">{{ $t('Address') }}</Title>

                        <div class="grid gap-x-2 gap-y-6 rounded-lg bg-gray-50 px-6 py-4 md:grid-cols-2 lg:grid-cols-3 lg:gap-x-8">
                            <div class="flex flex-col gap-1">
                                <div>{{ $t('Zipcode') }}</div>

                                <DisabledField>
                                    {{ billing_info?.zip_code }}
                                </DisabledField>
                            </div>
                            <div class="flex flex-col gap-1">
                                <div>{{ $t('Address') }}</div>

                                <DisabledField>
                                    {{ billing_info?.street }}
                                </DisabledField>
                            </div>

                            <div class="flex flex-col gap-1">
                                <div>{{ $t('Number') }}</div>

                                <DisabledField>{{ billing_info?.number }}</DisabledField>
                            </div>

                            <div class="flex flex-col gap-1">
                                <div>{{ $t('Complement') }}</div>

                                <DisabledField> {{ billing_info?.additional_info }} </DisabledField>
                            </div>

                            <div class="flex flex-col gap-1">
                                <div>{{ $t('Neighborhood') }}</div>

                                <DisabledField> {{ billing_info?.district }}</DisabledField>
                            </div>

                            <div class="flex flex-col gap-1">
                                <div>{{ $t('City') }}</div>

                                <DisabledField> {{ billing_info?.city }} </DisabledField>
                            </div>

                            <div class="flex flex-col gap-1">
                                <div>{{ $t('State') }}</div>

                                <DisabledField> {{ billing_info?.state }}</DisabledField>
                            </div>

                            <div class="flex flex-col gap-1">
                                <div>{{ $t('Country') }}</div>

                                <DisabledField> {{ billing_info?.country }}</DisabledField>
                            </div>
                        </div>
                    </fieldset>
                </section>
            </AccordionContent>
        </AccordionItem>
    </Accordion>
</template>
